// from: https://github.com/Flowm/satvis

import {
  Cartesian3,
  ConstantPositionProperty,
  ExtrapolationType,
  JulianDate,
  LagrangePolynomialApproximation,
  ReferenceFrame,
  SampledPositionProperty,
} from 'cesium';
import Orbit from './Orbit';

export class SatelliteProperties {
  constructor(name, tle) {
    this.name = name;
    // const lines = tle.split(/\r?\n/)
    // const line1 = lines.length == 3 ? lines[1] : lines[0]
    // const line2 = lines.length == 3 ? lines[2] : lines[1]
    this.orbit = new Orbit(this.name, tle);
    this.satnum = this.orbit.satnum;

    const sampledPosition = new SampledPositionProperty();
    sampledPosition.backwardExtrapolationType = ExtrapolationType.HOLD;
    sampledPosition.forwardExtrapolationType = ExtrapolationType.HOLD;
    sampledPosition.setInterpolationOptions({
      interpolationDegree: 5,
      interpolationAlgorithm: LagrangePolynomialApproximation,
    });
    this.sampledPosition = sampledPosition;

    const sampledPositionInertial = new SampledPositionProperty(
      ReferenceFrame.INERTIAL,
    );
    sampledPositionInertial.backwardExtrapolationType = ExtrapolationType.HOLD;
    sampledPositionInertial.forwardExtrapolationType = ExtrapolationType.HOLD;
    sampledPositionInertial.setInterpolationOptions({
      interpolationDegree: 5,
      interpolationAlgorithm: LagrangePolynomialApproximation,
    });
    this.sampledPositionInertial = sampledPositionInertial;

    this.updateSampledPosition(JulianDate.now());
  }

  computePositionCartesian3(julianDate) {
    // Check if Position for current timestap is already computed
    if (
      typeof this.lastPosition !== 'undefined' &&
            JulianDate.compare(this.lastDate, julianDate) == 0
    ) {
      return this.lastPosition;
    }

    this.lastDate = julianDate;
    const { longitude, latitude, height } = this.orbit.positionGeodetic(
      JulianDate.toDate(julianDate),
    );
    this.lastPosition = new Cartesian3.fromRadians(longitude, latitude, height);

    return this.lastPosition;
  }

  positionInertial(time, constprop = false) {
    const eci = this.orbit.positionECI(JulianDate.toDate(time));
    const position = new Cartesian3(eci.x * 1000, eci.y * 1000, eci.z * 1000);
    if (constprop) {
      return new ConstantPositionProperty(position, ReferenceFrame.INERTIAL);
    } else {
      return position;
    }
  }

  updateSampledPosition(
    reference,
    samplesFwd = 150,
    samplesBwd = 150,
    interval = 30,
  ) {
    const startTime = -samplesBwd * interval;
    const stopTime = samplesFwd * interval * 40;
    for (let time = startTime; time <= stopTime; time += interval) {
      const timestamp = JulianDate.addSeconds(
        reference,
        time,
        new JulianDate(),
      );

      this.sampledPosition.removeSample(timestamp);
      const position = this.computePositionCartesian3(timestamp);
      this.sampledPosition.addSample(timestamp, position);

      this.sampledPositionInertial.removeSample(timestamp);
      const positionInertial = this.positionInertial(timestamp);
      this.sampledPositionInertial.addSample(timestamp, positionInertial);
    }
  }
}
